<template>
  <div id="last-shows" v-if="showsList">
    <div class="row align-center">
      <div class="xxlarge-10 small-12 columns text-center">
        <h2>Últimas</h2>
      </div>
    </div>

    <div class="row align-center medium-collapse">
      <div class="xxlarge-10 medium-12 columns">
        <div class="row xxlarge-up-3 medium-up-2 xsmall-up-1 xsmall-collapse">
          <div
            class="column last-show-item"
            v-for="show in showsList"
            v-parallax="0.01"
            :key="show.exposicao_slug"
          >
            <router-link :to="`/exposicao/${show.exposicao_slug}`">
              <img
                :data-url="
                  show.exposicao_main_image.sizes['product-thumb-retina']
                "
                alt="Show 1"
                v-lazyload
              />
              <span
                v-if="show.exposicao_room.value != 'na'"
                v-bind:class="[show.exposicao_room.value]"
                class="label"
                ><span>{{ show.exposicao_room.label }}</span></span
              >
              <h3>{{ show.exposicao_title }}</h3>
              <h4 v-if="show.exposicao_main_author">
                {{ show.exposicao_main_author }}
              </h4>
              <h5>{{ show.exposicao_start_date }}</h5>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <span class="bg"></span>
  </div>
</template>

<script>
import eventBus from "../../eventBus";

export default {
  name: "lastShows",
  data() {
    return {
      shows_list: [],
      classArray: []
    };
  },
  beforeMount() {
    this.classArray = [this.$route.params.slug];
  },
  computed: {
    showsList() {
      eventBus.$emit("hide-loader");

      if (this.$route.params.slug != undefined)
        return this.$store.getters.getLastShowsByCategory(
          this.$route.params.slug
        );
      else return this.$store.getters.getLastShows;
    },
    room() {
      return this.$store.getters.getRoom(this.$route.params.slug);
    }
  },
  watch: {
    $route(to, from) {
      this.classArray = [this.$route.params.slug];
    }
  }
};
</script>
<!-- styling for the component -->
<style lang="scss">
#last-shows {
  .last-show-item {
    img {
      object-fit: cover;
      object-position: 50% 50%;
      width: 100%;
    }

    &:nth-child(1) {
      img {
        height: 265px;
      }
    }
    &:nth-child(2) {
      img {
        height: 340px;
      }
    }
    &:nth-child(3) {
      img {
        height: 300px;
      }
    }
  }

  .bg {
    display: none;
    position: absolute;
    top: 0;
    left: 40px;
    width: calc(100% - 80px);
    height: 100%;
    pointer-events: none;
    z-index: -1;
  }

  a {
    display: block;
  }

  h2 {
    font-family: "TT Norms";
    @include responsive-font-size(13px);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 30px;
  }

  h3 {
    font-family: "Libre Baskerville";
    @include responsive-font-size(26px);
    text-transform: initial;
    line-height: 1.35;
    letter-spacing: -0.25px;
    margin: 20px 0 5px;
  }

  h4 {
    @include responsive-font-size(14px);
    font-family: "Libre Baskerville";
    letter-spacing: 0;
    line-height: 1.3;
    margin-bottom: 15px;
    text-transform: none;
  }

  h5 {
    font-family: "TT Norms";
    @include responsive-font-size(13px);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: rgba(0, 0, 0, 0.3);
    margin-top: 10px;
  }

  .label {
    margin-top: 20px;
  }
}

@include max-screen($medium) {
  #last-shows {
    padding: 0 60px;
    .last-show-item {
      &:nth-child(1) {
        img {
          height: 340px;
        }
      }
      &:nth-child(3) {
        display: none;
      }
    }
  }
}

@include max-screen($small) {
  #last-shows {
    padding: 0 30px;

    .bg {
      left: 30px;
      width: calc(100% - 60px);
    }

    .last-show-item {
      &:nth-child(1),
      &:nth-child(2) {
        img {
          height: 200px;
        }
      }
    }
  }
}

@include max-screen($xsmall) {
  #last-shows {
    padding: 0 20px;

    .row .row {
      margin: 0;
    }

    .bg {
      left: 20px;
      width: calc(100% - 40px);
    }

    .last-show-item {
      margin-bottom: 60px;

      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3) {
        img {
          height: 245px;
        }
      }

      &:nth-child(3) {
        display: block;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@include max-screen($xxsmall) {
  #last-shows {
    .bg {
      left: 0;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/lastShows.vue